import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { filterQuery } from '@culture/common-helpers/url';
import {
	MetaPropType,
	NavigationPropType,
	PaginationPropType,
	PromoBlockPropType,
	RubricPropType,
	RubricTreePropType
} from 'propTypes/common';

import { Layout, LayoutBlock } from 'components/Layout';
import Container from 'components/Container';
import Rubricator from 'components/filters/Rubricator';
import CatalogTitleHeading from 'components/CatalogTitleHeading';
import PersonsFilterControls from './components/Filters';

import Catalog from './components/Catalog';
import EditorChoice from './components/EditorChoice';

import styles from './styles.module.scss';

const PersonsTemplate = ({
	persons,
	menu,
	urlParams,
	rubric,
	meta,
	topPromoBlock,
	rubricsTree,
	basePath,
	editorChoicePersons
}) => {
	const { push } = useRouter();
	const { total } = persons;

	const currentSelectedRubricPath = rubric?.path.replace(basePath, '');
	const changeUrl = (params) => {
		const { rubricPath: path, ...queryParams } = filterQuery(params);

		let urlPage = `/${basePath}/`;
		if (currentSelectedRubricPath && !path) {
			urlPage += currentSelectedRubricPath;
		}

		if (path) {
			urlPage += path;
		}
		push({
			pathname: urlPage,
			query: _(queryParams).pick('query', 'sort', 'cleanCache')
		});
	};

	const handleFilterChange = useCallback(
		(name, value) => {
			const currentValue = urlParams[name] || '';

			if (value !== currentValue) {
				const params = {
					...urlParams,
					[name]: value,
					page: null
				};
				changeUrl(params);
			}
		},
		[urlParams]
	);
	return (
		<Layout {...{ menu, rubric, meta, topPromoBlock }}>
			{!_(editorChoicePersons).isEmpty() && (
				<LayoutBlock theme="light" spacing="similar">
					<EditorChoice persons={editorChoicePersons} />
				</LayoutBlock>
			)}
			<LayoutBlock>
				<Container innerClassName={styles.Title}>
					<CatalogTitleHeading
						{...{ headingTitle: meta?.headingTitle, total }}
					/>
				</Container>
			</LayoutBlock>
			<LayoutBlock gutter="mediumConstant">
				<Container>
					<PersonsFilterControls
						{...{ urlParams, rubricsTree, handleFilterChange }}
					/>
				</Container>
			</LayoutBlock>
			{!_.isEmpty(rubricsTree.children) ? (
				<LayoutBlock gutter="mediumConstant">
					<Container>
						<Rubricator
							{...{
								rubricsTree,
								setFilter: handleFilterChange,
								rootRubricPath: basePath,
								currentRubricPath: rubric?.path
							}}
						/>
					</Container>
				</LayoutBlock>
			) : null}
			<LayoutBlock>
				<Container>
					<Catalog
						{...{
							persons
						}}
					/>
				</Container>
			</LayoutBlock>
		</Layout>
	);
};

PersonsTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	urlParams: PropTypes.object.isRequired,
	persons: PropTypes.shape({
		pagination: PaginationPropType.isRequired,
		total: PropTypes.number,
		items: PropTypes.array.isRequired
	}),
	rubric: RubricPropType,
	meta: MetaPropType.isRequired,
	rubricsTree: RubricTreePropType.isRequired,
	basePath: PropTypes.string.isRequired,
	topPromoBlock: PromoBlockPropType,
	editorChoicePersons: PropTypes.array
};

export default PersonsTemplate;
